import React, {useState, useEffect, useRef, useMemo} from "react";
import {Links} from '../routes/PathLink'
import { Link } from "react-router-dom";

const Breadcrumb = ({breadcrumb}) => {

    return(
        <div className="flex flex-wrap items-center gap-2 py-5">
            {
            breadcrumb?.map((val, key) => (
                val.link ?
                <><Link className="text-accent" to={`${val.link}`}><div>{val.name}</div></Link>
                <div>/</div></>
                :
                <div>{val.name}</div>
            ))
            }
        </div>
    )

}

export default Breadcrumb;
